import React from 'react'
import PropTypes from 'prop-types'
import { classNames } from 'utils/utils'

const drawn = {
  NoEdge:
    'M5.566 10.752a.5.5 0 0 1 .868.496l-2.567 4.5a.5.5 0 0 1-.435.252H.5a.5.5 0 1 1 0-1h2.642l2.424-4.248zM12.858 1l-2.424 4.248a.5.5 0 0 1-.868-.496l2.567-4.5A.5.5 0 0 1 12.568 0H15.5a.5.5 0 0 1 0 1h-2.642zM4 7h8v2H4V7z',
  BothEdges:
    'M3.5 0h9a.5.5 0 0 1 .5.5V8h3l-3 6v1h2.5a.5.5 0 1 1 0 1h-3a.5.5 0 0 1-.5-.5V14L9 8h3V1H4v1l3 6H4v7.5a.5.5 0 0 1-.5.5h-3a.5.5 0 1 1 0-1H3V8H0l3-6V.5a.5.5 0 0 1 .5-.5z',
  FallingEdge:
    'M7.195 5.686L3.933.25A.5.5 0 0 0 3.491 0H.5a.5.5 0 1 0 0 1h2.717l3.12 5.2L4 7.606l5.54 3.933 2.531 4.22A.5.5 0 0 0 12.5 16h3a.5.5 0 1 0 0-1h-2.717l-1.734-2.89L10 4 7.195 5.686z',
  RisingEdge:
    'M10.376 5.011L9.04 12.32l-2.17-1.464-2.94 4.902A.5.5 0 0 1 3.5 16h-3a.5.5 0 1 1 0-1h2.717l2.823-4.705-2.804-1.89 6.356-4.03L12.067.251A.5.5 0 0 1 12.509 0H15.5a.5.5 0 1 1 0 1h-2.717l-2.407 4.011z',
}

const EdgeImg = ({ edge, className, 'data-img-value': dataImgValue }) => (
  <span
    className={classNames(className, 'edge-image')}
    data-img-value={dataImgValue}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path
        className="edge-image-path"
        fill="#07070F"
        fillOpacity=".87"
        fillRule="evenodd"
        d={drawn[edge]}
      />
    </svg>
  </span>
)

EdgeImg.propTypes = {
  edge: PropTypes.string,
  className: PropTypes.string,
  'data-img-value': PropTypes.string,
}

export default EdgeImg
